exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-inputtextarea{margin-top:4px}.suggestion-item{display:block;cursor:pointer;background-color:#deb887}.suggestion-item:hover{color:#fff;background-color:#000}.suggestion-panel{display:none;margin-left:7px}.fill-whole-div{width:50vw!important;height:20vh!important}", ""]);

// exports
